export const HOSPITALIZATION_ROUTES = {
  order              : 'formulario/orden',
  historyPatient     : 'historial/paciente',
  historyProfessional: 'historial/profesional',
};
